import { defineStore } from 'pinia'
import npsApi from '@vue3/api/nps-api.js'

const npsStore = defineStore('npsStore', {

  state: () => ({
    showNPSPopup: false,
    feedbackId: null
  }),
  actions: {
    setNpsDetatis (showNPSPopup, feedbackId) {
      this.showNPSPopup = showNPSPopup
      this.feedbackId = feedbackId
    },
    saveNpsFeedback ({ payload, success, fail }) {
      npsApi.saveNpsFeedback(payload).then(response => {
        if (response.body.success) {
          this.showNPSPopup = false
          this.feedbackId = null
          success && success(response.body)
        } else {
          fail && fail()
        }
      }).catch(() => {
        fail && fail()
      })
    },
    cancelNpsFeedback ({ payload, success, fail }) {
      npsApi.cancelNpsFeedback(payload).then(response => {
        if (response.body.success) {
          this.showNPSPopup = false
          this.feedbackId = null
          success && success(response.body)
        } else {
          fail && fail()
        }
      }).catch(() => {
        fail && fail()
      })
    }
  }
})
export default npsStore
